class MappingBase {
  /**
   * Converts alias-based data to full property names (deserialization).
   * @param {Object} aliasData - The object with alias-based keys.
   * @returns {Object} - The deserialized object with full property names.
   */
  static fromAlias(aliasData) {
    const mapping = this.getCombinedMapping("_aliasMapping");
    const deserializedData = {};

    for (const [aliasKey, value] of Object.entries(aliasData)) {
      const fullKey = mapping[aliasKey] || aliasKey; // Default to original key if no alias mapping exists
      deserializedData[fullKey] = value;
    }

    return new this(deserializedData);
  }

  /**
   * Converts full property names to alias-based keys (serialization).
   * @param {Object} instanceData - The object instance to serialize.
   * @returns {Object} - The serialized object with alias-based keys.
   */
  toAlias() {
    const mapping = this.constructor.getCombinedMapping("_aliasMapping");
    const serializedData = {};

    for (const [key, value] of Object.entries(this)) {
      const aliasKey = Object.keys(mapping).find((k) => mapping[k] === key) || key;
      serializedData[aliasKey] = value;
    }

    return serializedData;
  }

  /**
   * Combines mappings or exclusions by traversing inheritance.
   * @param {string} attributeName - The name of the attribute to combine.
   * @returns {Object} - The combined mapping.
   */
  static getCombinedMapping(attributeName) {
    let combined = {};
    let cls = this;

    while (cls) {
      if (cls[attributeName]) {
        combined = { ...cls[attributeName], ...combined }; // Merge mappings
      }
      cls = Object.getPrototypeOf(cls);
    }

    return combined;
  }
}

export default MappingBase;
